module.exports = __webpack_public_path__ + "static/media/timeSeries.5eee2ae7.png";